import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

const useStyles = makeStyles((theme: any) => ({
  modal: {
    '& .MuiDialog-paper': {
      maxWidth: '700px' + '!important',
      [theme.breakpoints.down('sm')]: {
        width: 'calc(100vw - 40px) !important',
        maxWidth: 'calc(100vw - 40px) !important',
      },
    },
  },
  modalContent: {
    height: '610px' + '!important',
    padding: '24px 24px !important',
    minWidth: '650px',
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%',
    },
  },
  pdfContainer: {
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  pdfPage: {
    border: '1px solid #ccc',
    marginTop: '24px',
    '& canvas': {
      maxWidth: '100%',
      height: 'auto !important',
    },
    [theme.breakpoints.down('sm')]: {
      '& canvas': {
        maxWidth: '100%',
        width: '100% !important',
        height: 'auto !important',
      },
    },
  },
  pdfMargin: {
    width: '22px',
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '50px',
    height: '100%',
  },
  noDataText: {
    textAlign: 'center',
    padding: 4,
    fontSize: '16px',
    color: STYLE.COLOR.TEXT1,
    marginTop: '50px',
  },
}));

export default useStyles;
